import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {DateAdapter} from '@angular/material/core';
import {MatExpansionPanel} from '@angular/material/expansion';
import {PageEvent} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import {Claim2CustomerI, Claim2UserI} from '../../../../../../interfaces/claim.interface';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {AppService} from '../../../../../../../../app.service';
import {AuthService} from '../../../../../../../../core/auth/auth.service';
import {DialogButton, DialogData, DialogService} from '../../../../../../../../core/services/dialog.service';
import {RouterService} from '../../../../../../../../core/services/router.service';
import {Pager} from '../../../../../../interfaces/pager';
import {UserFind} from '../../../../../../interfaces/user-find';
import {InvitationDialogComponent} from './components/invitation-dialog/invitation-dialog.component';
import {CustomerData} from "../../../../../../interfaces/customer-data";
import {UserI} from '../../../../../../interfaces/user.interface';

@Component({
  selector: 'app-claim-edit',
  templateUrl: './claim-edit.component.html',
  styleUrls: ['./claim-edit.component.scss']
})
export class ClaimEditComponent implements OnInit, OnDestroy {

  @Input() customerData: CustomerData;
  @Input() expansionPanel: MatExpansionPanel;
  @Input() c2c: Claim2CustomerI;
  @Input() c2cFormGroup: FormGroup;
  @Input() c2cForm: FormGroup;

  constructor(private dateAdapter: DateAdapter<any>,
              public router: RouterService,
              public app: AppService,
              public dialog: DialogService,
              public fb: FormBuilder,
              private auth: AuthService) {
    dateAdapter.setLocale('de');
  }

  private unsubscribe$ = new Subject<void>();

  public subscribersLoaded = false;

  subscribersDataSource = null;

  displayedColumns: string[] = [
    'icon',
    'name',
    'email',
    'delete',
    'edit',
  ];

  pager: Pager = {
    length: null,
    pageSize: 5,
    pageIndex: 0,
    sortCol: null,
    sortOrder: null
  };

  ngOnInit(): void {
    if (this.expansionPanel) {
      this.expansionPanel.afterExpand
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(() => {
          this.getSubscribers();
        })
    }

    if (!this.c2c || !this.c2cFormGroup) {
      this.initNewClaim2Customer();
    }
  }

  initNewClaim2Customer() {
    this.c2c = {
      claim_datatype: "",
      claim_name: "sta_user_domain_admin",
      claim_value: "true",
      crc32: "",
      expires: "",
      external_claim_id: "",
      external_customer_id: "",
      id: "",
      max_sessions_per_user: 1,
      max_user_count: 1,
      md5: "",
      scope: "sso",
      start: (new Date()).toISOString()
    }

    this.c2cFormGroup = this.fb.group({
      'scope': this.c2c.scope,
      'claim_name': this.c2c.claim_name,
      'claim_value': this.c2c.claim_value === 'true',
      'external_claim_id': {value: this.c2c.external_claim_id, disabled: true},
      'start': this.c2c.start,
      'expires': this.c2c.expires,
      'max_user_count': this.c2c.max_user_count,
      'max_sessions_per_user': this.c2c.max_sessions_per_user,
    });

    this.c2cFormGroup.get('claim_name').valueChanges.subscribe(change => {
      let customerId = this.customerData.customer.external_id;
      this.c2c.external_claim_id = customerId + '_' + change;
    })
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  open(user: UserI) {
    this.router.navigateByUrl('/admin/users/edit/' + user.id);
  }

  deleteClaim2User(c: Claim2UserI, claimI: number = null) {
    const y: DialogButton = {
      name: 'Ja',
      color: 'warn',
      handler: () => {
        console.log('confirm');
        dialRef.close();
        this.app.claim2userDelete(c.id).then(res => {
          if (res) {
            if (claimI) {
              this.c2c.claims2user.splice(claimI, 1);
            } else {
              this.getSubscribers(true);
            }

            this.app.toast.open('Der Zugang wurde gelöscht');
          }
        }).catch(err => {
          this.app.toast.open('Unbekannter Fehler', null, {
            panelClass: 'warn'
          });
        });
      }
    };

    const n: DialogButton = {
      name: 'Abbrechen',
      handler: () => {
        dialRef.close();
      }
    };

    const data: DialogData = {
      subTitle: 'Wollen Sie den Nutzer-Zugang löschen?',
      buttons: [y, n]
    };

    const dialRef = this.dialog.alert(data, {width: '50vh'});
  }

  saveClaim2Customer() {
    if (this.c2cFormGroup.valid) {
      const c2c = Object.assign({}, this.c2c) as Claim2CustomerI;
      const c2cValues = this.c2cFormGroup.value as { [key: string]: string | boolean };
      for (let k in c2cValues) {

        if (c2c.hasOwnProperty(k) && c2cValues.hasOwnProperty(k)) {
          switch (k) {
            case 'start':
              c2c[k] = this.app.dateFormatToDB(c2cValues[k]);
              break;
            case 'expires':
              c2c[k] = this.app.dateFormatToDB(c2cValues[k]);
              break;
            case 'claim_value':
              c2c[k] = c2cValues[k] ? 'true' : 'false';
              break;
            default:
              c2c[k] = c2cValues[k];
              break;
          }
        }
      }

      if (!c2c.id) {
        c2c.customerId = this.customerData.customer.id;
        c2c.external_customer_id = this.customerData.customer.external_id;

        if(!c2c.external_claim_id) {
          c2c.external_claim_id = c2c.external_customer_id + '_' + c2c.claim_name;
        }

        c2c.claim_datatype = 'boolean';
        //create
        this.app.claim2customerCreate(c2c, this.auth.user.id).then(res => {
          if (res) {
            this.c2c = res;
            this.addScopedClaim2Customer(this.c2c);
            this.app.toast.open('Zugang erstellt');
          }
        }).catch(err => {
          this.app.toast.open('Unbekannter Fehler', null, {
            panelClass: 'warn'
          });
        });
      } else {
        //update
        this.app.claim2customerUpdate(c2c, this.auth.user.id).then(res => {
          if (res) {
            this.c2c = c2c;
            this.app.toast.open('Zugang aktualisiert');
          }
        }).catch(err => {
          this.app.toast.open('Unbekannter Fehler', null, {
            panelClass: 'warn'
          });
        });
      }
    } else {
      console.log('form invalid');
    }
  }

  deleteClaim2Customer(c2c: Claim2CustomerI) {
    const y: DialogButton = {
      name: 'Ja',
      color: 'warn',
      handler: () => {
        console.log('confirm');
        dialRef.close();

        this.app.claim2customerDelete(c2c.id).then(res => {
          if (res) {
            if (c2c) {
              let desc = this.customerData.all_scopes.find(sc => sc.name === c2c.scope).desc;
              let index = this.customerData.scopedClaims2customer.findIndex(el => el.desc === desc);
              let spliced = this.customerData.scopedClaims2customer.slice(index, 1);
              if (spliced) {
                this.c2c = null;
              }
            }

            this.app.toast.open('Der Zugang wurde gelöscht');
          }
        }).catch(err => {
          this.app.toast.open('Unbekannter Fehler', null, {
            panelClass: 'warn'
          });
        });
      }
    };

    const n: DialogButton = {
      name: 'Abbrechen',
      handler: () => {
        dialRef.close();
      }
    };

    const data: DialogData = {
      subTitle: 'Wollen Sie den Zugang löschen?',
      buttons: [y, n]
    };

    const dialRef = this.dialog.alert(data, {width: '50vh'});
  }

  addScopedClaim2Customer(c2c: Claim2CustomerI) {
    if (c2c) {
      let desc = this.customerData.all_claims.find(c => c.name === c2c.claim_name).desc;
      c2c.desc = desc || '';

      if (this.c2cForm) {
        let hasControl = this.c2cForm.get(c2c.external_claim_id);
        if (!hasControl) {
          this.c2cForm.addControl(
            c2c.external_claim_id,
            this.fb.group({
              'scope': c2c.scope,
              'claim_name': c2c.claim_name,
              'external_claim_id': {value: c2c.external_claim_id, disabled: true},
              'claim_value': c2c.claim_value === 'true',
              'start': c2c.start,
              'expires': c2c.expires,
              'max_user_count': c2c.max_user_count,
              'max_sessions_per_user': c2c.max_sessions_per_user,
            }))
        }
      }

      if (this.customerData.scopedClaims2customer) {
        let desc = this.customerData.all_scopes.find(s => s.name === c2c.scope).desc;
        if (desc) {
          let found = this.customerData.scopedClaims2customer.find(sc => {
            if (sc.desc === desc) {
              console.log('push')
              sc.claims.push(c2c);
              return true;
            }
          })

          if (!found) {
            this.customerData.scopedClaims2customer.push({desc: desc, name: c2c.scope, claims: [c2c], total: 1})
          }
        }
      }
    }
  }

  invitationModal() {
    const dialRef = this.dialog.open(InvitationDialogComponent, {data: this.c2c, width: '500px'});
    dialRef.afterClosed().subscribe(email => {
      console.log(email);
      if (email) {
        this.app.newInvitation({c2cId: this.c2c.id, email: email}).then(res => {
          if (res) {
            this.app.toast.open('Einladungs-E-Mail wurde erfolgreich gesendet');
          }
        }).catch(err => {
          this.app.toast.open('Unbekannter Fehler', null, {
            panelClass: 'warn'
          });
        });
      }
    })
  }

  privateClaim() {
    return this.c2c.external_customer_id.includes('@');
  }

  getSubscribers(pager = false) {
    if (!this.subscribersLoaded || pager) {

      this.app.dialog.loader({
        title: 'Suche nach Benutzern'
      });

      const params: UserFind = {input: this.c2c.id, column: 'c2c_id', pager: this.pager};

      this.app.customerClaimSubscribers(params).then(data => {
        this.subscribersLoaded = true;
        this.c2c.claims2user = data.found;

        this.app.dialog.closeLoader();
        this.pager.length = data.total;
        this.subscribersDataSource = new MatTableDataSource(data.found);
      })
    }
  }

  switchPage(e: PageEvent) {
    this.pager.pageIndex = e.pageIndex;
    this.pager.pageSize = e.pageSize;
    // console.log(e, this.pager);
    this.getSubscribers(true);
  }

  sortResults(sort: any) {
    if (sort.active && sort.direction) {
      this.pager.sortCol = sort.active;
      this.pager.sortOrder = sort.direction;
      this.getSubscribers(true);
    }
  }

}
